var timer;
var timerStart;
var timeSpentOnSite = getTimeSpentOnSite();

function getTimeSpentOnSite() {
    timeSpentOnSite = parseInt(sessionStorage.getItem('timeSpentOnSite'));
    timeSpentOnSite = isNaN(timeSpentOnSite) ? 0 : timeSpentOnSite;
    return timeSpentOnSite;
}

function startCounting() {
    timerStart = Date.now();
    timer = setInterval(function () {
        timeSpentOnSite = getTimeSpentOnSite() + (Date.now() - timerStart);
        sessionStorage.setItem('timeSpentOnSite', timeSpentOnSite);
        timerStart = parseInt(Date.now());
        // Convert to seconds
        var seconds = parseInt(timeSpentOnSite / 1000);
        // Number here respresents the seconds threshold
        if (seconds >= 150) {
            window.usabilla_live('trigger', 'WebsiteResearch');
            clearInterval(timer);
        }
    }, 1000);
}
startCounting();